import React from "react";

import { NOTIFICATION_CONSTANTS } from "constants/notificationConstants";
const NotificationContext = React.createContext();

const initialState = {
  count: 0,
  data: [],
  tab: "All",
};

const notificationReducer = (state, action) => {
  switch (action.type) {
    case NOTIFICATION_CONSTANTS.CHANGE_NOTIFICATION_TAB:
      return {
        ...state,
        tab: action.payload,
      };

    case NOTIFICATION_CONSTANTS.SET_NOTIFICATION:
      return {
        ...state,
        data: action.payload.data,
        count: action.payload.count,
      };

    case NOTIFICATION_CONSTANTS.ADD_NEW_NOTIFICATION:
      return {
        ...state,
        data: [action.payload.newData, ...state.data],
        count: state.count + 1,
      };

    case NOTIFICATION_CONSTANTS.READ_NOTIFICATION:
      let newData = [...state.data];

      if (state.tab === "All") {
        const newData = state.data.map((item) =>
          item._id === action.payload.id
            ? { ...item, isInReadByField: true }
            : item
        );

        return {
          ...state,
          data: newData,
          count: state.count - 1,
        };
      } else {
        let onRead = newData.filter((item) => item._id !== action.payload.id);
        return {
          ...state,
          data: onRead,
          count: state.count - 1,
        };
      }

    case NOTIFICATION_CONSTANTS.READ_ALL_NOTIFICATION:
      const updatedList = state.data.map((item) => {
        return {
          ...item,
          isInReadByField: true,
        };
      });
      return {
        ...state,
        data: updatedList ?? [],
        count: 0,
      };

    default:
      return { ...state };
  }
};

const useNotificationContext = () => React.useContext(NotificationContext);

const NotificationProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(notificationReducer, initialState);
  const value = {
    state,
    dispatch,
  };
  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

export { NotificationProvider, useNotificationContext };
